import React from 'react';
import PropTypes from 'prop-types';

import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

function ShopIcon({
  className,
  color,
  containerColor,
  containerSize,
  onClick,
  round,
  size,
}) {
  return (
    <WithIconRounded
      className={className}
      containerColor={containerColor}
      containerSize={containerSize}
      onClick={onClick}
      round={round}
    >
      <svg width={size} height={size} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.50049 -0.000366211H14.5005C14.6557 -0.000366211 14.8088 0.0357788 14.9477 0.105206C15.0866 0.174634 15.2073 0.275438 15.3005 0.399634L18.0005 3.99963V18.9996C18.0005 19.2649 17.8951 19.5192 17.7076 19.7067C17.5201 19.8943 17.2657 19.9996 17.0005 19.9996H1.00049C0.735272 19.9996 0.480918 19.8943 0.293381 19.7067C0.105845 19.5192 0.000488281 19.2649 0.000488281 18.9996V3.99963L2.70049 0.399634C2.79364 0.275438 2.91442 0.174634 3.05327 0.105206C3.19213 0.0357788 3.34524 -0.000366211 3.50049 -0.000366211ZM16.0005 5.99963H2.00049V17.9996H16.0005V5.99963ZM15.5005 3.99963L14.0005 1.99963H4.00049L2.50049 3.99963H15.5005ZM6.00049 7.99963V9.99963C6.00049 10.7953 6.31656 11.5583 6.87917 12.121C7.44178 12.6836 8.20484 12.9996 9.00049 12.9996C9.79614 12.9996 10.5592 12.6836 11.1218 12.121C11.6844 11.5583 12.0005 10.7953 12.0005 9.99963V7.99963H14.0005V9.99963C14.0005 11.3257 13.4737 12.5975 12.536 13.5352C11.5983 14.4728 10.3266 14.9996 9.00049 14.9996C7.67441 14.9996 6.40264 14.4728 5.46495 13.5352C4.52727 12.5975 4.00049 11.3257 4.00049 9.99963V7.99963H6.00049Z" fill={color} />
      </svg>
    </WithIconRounded>
  );
}

ShopIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

ShopIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: 'var(--k-ds-color-grey-900)',
  containerColor: null,
  containerSize: 40,
  onClick: null,
  round: false,
  size: 14,
};

export default ShopIcon;
